<span class="line-clamp-3 break-after-all">
  {{ processedValue() }}
</span>
